import { type FC, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { CalendarRootContext } from './context/calendar-root.context';
import { calendarMonthStyles } from './styles/calendar-month.styles';
import type { CalendarMonthPropsInterface } from './types/calendar-month.types';

export const CalendarMonth: FC<CalendarMonthPropsInterface> = (props) => {
  const { children, css: cssProp, className, ...rest } = props;

  const { calendar } = useContext(CalendarRootContext);

  const styles = css(calendarMonthStyles, cssProp);

  return (
    <span
      role="columnheader"
      data-c11n-component="Calendar.Month"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', styles, className)}
      id={calendar?.headerId}
      {...rest}
    >
      {children}
    </span>
  );
};

CalendarMonth.displayName = 'Calendar.Month';
